/* NS Cart — drawer del carrito y "añadir al carrito" propios.
   Sustituye al JS de carrito de XTRA (custom-async.js: updateCartPanel, handleCartPanel...).
   Captura en fase de captura cualquier <form action="/cart/add"> de la tienda, así que
   también cubre formularios que aún pinta XTRA (buscador, relacionados...). */
(function () {
  'use strict';
  if (window.NSCart) return;

  var UNDO_MS = 5000;
  var lastFocus = null;
  var undoTimer = null;

  function wrapper() {
    var el = document.getElementById('ns-drawer');
    return el ? el.closest('.shopify-section') : null;
  }
  function sectionId() {
    var w = wrapper();
    return w ? w.id.replace('shopify-section-', '') : 'ns-drawer';
  }
  function drawer() { return document.getElementById('ns-drawer'); }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'ns-toast';
    t.setAttribute('role', 'alert');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: cur }).format(cents / 100);
  }

  function updateBadge(count) {
    var link = document.getElementById('ns-gnav-cart-link');
    if (!link) return;
    var badge = document.getElementById('ns-gnav-cart-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ns-gnav-cart-badge';
        badge.id = 'ns-gnav-cart-badge';
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function render(sections) {
    var html = sections && sections[sectionId()];
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('ns-drawer');
    var current = drawer();
    if (!fresh || !current) return false;
    var wasOpen = current.classList.contains('is-open');
    if (wasOpen) fresh.classList.add('is-open');
    fresh.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
    current.replaceWith(fresh);
    updateBadge(Number(fresh.dataset.count) || 0);
    loadSuggestions();
    return true;
  }

  function refresh() {
    return fetch('/?sections=' + encodeURIComponent(sectionId()))
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ns-drawer-lock');
    var close = d.querySelector('[data-ns-close]');
    if (close) close.focus();
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ns-drawer-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function post(url, body, isJson) {
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (isJson) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se ha podido actualizar el carrito');
        return data;
      });
    });
  }

  function add(form) {
    var fd = form instanceof FormData ? form : new FormData(form);
    fd.set('sections', sectionId());
    fd.set('sections_url', window.location.pathname);
    return post('/cart/add.js', fd, false)
      .then(function (data) {
        if (!render(data.sections)) return refresh();
      })
      .then(open)
      .catch(function (err) { toast(err.message); });
  }

  function addItem(id, qty) {
    var fd = new FormData();
    fd.set('id', id);
    fd.set('quantity', qty || 1);
    return add(fd);
  }

  function change(line, qty) {
    return post('/cart/change.js', { line: line, quantity: qty, sections: sectionId(), sections_url: window.location.pathname }, true)
      .then(function (data) { render(data.sections); })
      .catch(function (err) { toast(err.message); });
  }

  function showUndo(variant, qty, title) {
    var box = drawer() && drawer().querySelector('[data-ns-undo]');
    if (!box) return;
    box.hidden = false;
    box.innerHTML = '<span></span><button type="button" data-ns-undo-btn>Deshacer</button>';
    box.firstChild.textContent = title + ' eliminado';
    box.querySelector('button').addEventListener('click', function () {
      clearTimeout(undoTimer);
      addItem(variant, qty);
    });
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { box.hidden = true; }, UNDO_MS);
  }

  function loadSuggestions() {
    var d = drawer();
    var box = d && d.querySelector('[data-ns-suggest]');
    if (!box || !box.dataset.product) return;
    var inCart = Array.prototype.map.call(d.querySelectorAll('[data-pid]'), function (l) { return l.dataset.pid; });
    fetch('/recommendations/products.json?product_id=' + box.dataset.product + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = box.querySelector('.ns-dr-sug-list');
        var items = (data.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, 3);
        if (!items.length) return;
        items.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'ns-dr-sug';
          var img = document.createElement('img');
          img.src = p.featured_image || ''; img.alt = ''; img.loading = 'lazy';
          var info = document.createElement('div');
          var name = document.createElement('b'); name.textContent = p.title;
          var price = document.createElement('span'); price.textContent = money(p.price);
          info.appendChild(name); info.appendChild(price);
          var action;
          if (p.variants.length === 1) {
            action = document.createElement('button');
            action.type = 'button'; action.className = 'ns-dr-btn ns-btn-reset'; action.style.width = 'auto'; action.style.margin = '0'; action.style.padding = '8px 14px';
            action.textContent = 'Añadir';
            action.addEventListener('click', function () { action.disabled = true; addItem(p.variants[0].id, 1); });
          } else {
            action = document.createElement('a');
            action.className = 'ns-dr-btn ns-btn-reset'; action.style.width = 'auto'; action.style.margin = '0'; action.style.padding = '8px 14px';
            action.href = p.url; action.textContent = 'Ver';
          }
          li.appendChild(img); li.appendChild(info); li.appendChild(action);
          list.appendChild(li);
        });
        box.hidden = false;
      })
      .catch(function () {});
  }

  // Añadir al carrito: cualquier formulario /cart/add de la tienda (fase de captura).
  function isAddForm(f) {
    return f && f.matches && f.matches('form[action*="/cart/add"]') && !f.hasAttribute('data-ns-native');
  }
  document.addEventListener('submit', function (e) {
    if (!isAddForm(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    add(e.target);
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var btn = t.closest('button[type="submit"], input[type="submit"], button:not([type])');
    if (btn && btn.form && isAddForm(btn.form) && !t.closest('shopify-accelerated-checkout, .shopify-payment-button')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      add(btn.form);
      return;
    }
    if (t.closest('[data-ns-close]')) { close(); return; }
    if (t.closest('[data-ns-open-cart]')) { e.preventDefault(); open(); return; }
    var qty = t.closest('[data-ns-qty]');
    if (qty) {
      var next = Number(qty.dataset.qty) + Number(qty.dataset.nsQty);
      change(Number(qty.dataset.line), Math.max(0, next));
      return;
    }
    var rm = t.closest('[data-ns-remove]');
    if (rm) {
      var v = rm.dataset.variant, q = Number(rm.dataset.qty), title = rm.dataset.title;
      change(Number(rm.dataset.line), 0).then(function () { showUndo(v, q, title); });
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.NSCart = { open: open, close: close, refresh: refresh, add: add, addItem: addItem, change: change };
  document.addEventListener('DOMContentLoaded', loadSuggestions);
})();
